import React, { Component, useEffect, useState } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import MetisMenu from 'metismenujs'
import { useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'

class MM extends Component {
  componentDidMount() {
    this.$el = this.el
    this.mm = new MetisMenu(this.$el)
  }
  componentWillUnmount() {
    //  this.mm("dispose");
    // console.log(this.mm);
  }
  render() {
    return (
      <div className="mm-wrapper" style={{ marginBottom: '100px' }}>
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    )
  }
}

export default function Sidebar(props) {
  const { checkSizeDevice, setShowArrowIcon } = props
  const admin = useSelector((state) => state.admin)
  let location = useLocation()
  const history = useHistory()
  const [path, setPath] = useState('')

  /// Active menu
  let listMenu = [
    { title: 'admin', permission: 'admin', icon: 'flaticon-381-layer-1' },
    { title: 'refund', permission: 'refund', icon: 'fa fa-money' },
    {
      title: 'affiliate',
      permission: 'affiliate',
      icon: 'flaticon-381-shuffle-1',
    },
    {
      title: 'kyc',
      permission: 'kyc',
      icon: 'fa fa-address-card-o',
    },
    {
      title: 'recheckPrizes',
      permission: 'recheckPrizes',
      icon: 'fa fa-money',
    },
    {
      title: 'recheckPrizes2',
      permission: 'recheckPrizes2',
      icon: 'fa fa-money',
    },
    {
      title: 'recheckShipping',
      permission: 'recheckShipping',
      icon: 'fa fa-qrcode',
    },
    //{ title: "agent", permission: "agent", icon: "flaticon-381-user-8" },
    {
      title: 'announcements',
      permission: 'announcements',
      icon: 'la la-broadcast-tower',
    },
    { title: 'badQR', permission: 'round', icon: 'fa fa-money' },
    { title: 'books', permission: 'books', icon: 'flaticon-381-book' },
    { title: 'campaign', permission: 'campaign', icon: 'fa fa-magnet' },
    { title: 'adBanner', permission: 'adBanner', icon: 'fa fa-magic' },
    { title: 'config', permission: 'config', icon: 'fa fa-magnet' },
    { title: 'bookBankCollection', permission: 'bookBankCollection', icon: 'fa fa-money' },
    { title: 'coupon', permission: 'coupon', icon: 'fa fa-money' },
    { title: 'credit', permission: 'credit', icon: 'fa fa-credit-card' },
    {
      title: 'dashboard-draft',
      permission: 'dashboard-draft',
      icon: 'fa fa-tachometer',
    },
    { title: 'fcm', permission: 'fcm', icon: 'la la-broadcast-tower' },
    { title: 'gifts', permission: 'gifts', icon: 'flaticon-381-gift' },
    { title: 'log', permission: 'log', icon: 'fa fa-sign-in' },
    { title: 'lottery', permission: 'lottery', icon: 'fa fa-money' },
    { title: 'lotteryLive', permission: 'lotteryLive', icon: 'fa fa-money' },
    { title: 'lotteryTemp', permission: 'lotteryTemp', icon: 'fa fa-money' },
    { title: 'lotterySafe', permission: 'lotterySafe', icon: 'fa fa-shield' },
    { title: 'luckyNumber', permission: 'luckyNumber', icon: 'fa fa-money' },
    { title: 'monitor', permission: 'monitor', icon: 'fa fa-bell' },
    {
      title: 'numberOfPrizes',
      permission: 'numberOfPrizes',
      icon: 'fa fa-money',
    },
    { title: 'order', permission: 'order', icon: 'fa fa-shopping-basket' },
    { title: 'payment', permission: 'payment', icon: 'fa fa-shopping-basket' },
    {
      title: 'preOrder',
      permission: 'preOrder',
      icon: 'fa fa-shopping-basket',
    },
    {
      title: 'orderExtras',
      permission: 'orderExtras',
      icon: 'fa fa-shirtsinbulk',
    },
    {
      title: 'payOutMhee',
      permission: 'payOutMhee',
      icon: 'fa fa-shopping-basket',
    },
    { title: 'refunds', permission: 'refunds', icon: 'fa fa-shopping-basket' },
    { title: 'round', permission: 'round', icon: 'fa fa-map-signs' },
    { title: 'scaning', permission: 'scaning', icon: 'fa fa-qrcode' },
    { title: 'ScaningTeam', permission: 'ScaningTeam', icon: 'fa fa-barcode' },
    { title: 'tempImport', permission: 'round', icon: 'flaticon-381-book' },
    // { title: "transfer", permission: "transfer", icon: "flaticon-381-transfer" },
    {
      title: 'payOut',
      permission: 'payOut',
      icon: 'flaticon-381-transfer',
    },
    {
      title: 'transferMhee',
      permission: 'transferMhee',
      icon: 'flaticon-381-transfer',
    },
    {
      title: 'transferSlip',
      permission: 'transferSlip',
      icon: 'fa fa-slideshare',
    },
    { title: 'user', permission: 'user', icon: 'fa fa-user-circle' },
    {
      title: 'userPrizes',
      permission: 'userPrizes',
      icon: 'flaticon-381-resume',
    },
    {
      title: 'withdrawalRequest',
      permission: 'withdrawalRequest',
      icon: 'flaticon-381-shuffle-1',
    },
    {
      title: 'moveLottery',
      permission: 'moveLottery',
      icon: 'flaticon-381-shuffle-1',
    },
    {
      title: 'openBox',
      permission: 'openBox',
      icon: 'fa fa-money',
    },
    {
      title: 'highlightLottery',
      permission: 'highlightLottery',
      icon: 'fa fa-money',
    },
    {
      title: 'editPolicy',
      permission: 'editPolicy',
      icon: 'flaticon-381-book',
    },
    {
      title: 'lotteryCountByNumber',
      permission: 'lotteryCountByNumber',
      icon: 'fa fa-money',
    },
    //{ title: "prize",permission:"", icon: "fa fa-dollar" },
    //{ title: "saleLottery",permission:"saleLottery", icon: "fa fa-money" },
    //{ title: "withdrawal",permission:"withdrawal", icon: "flaticon-381-shuffle-1" },
    { title: 'page-error-400', icon: 'fa fa-exclamation' },
    { title: 'page-error-403', icon: 'fa fa-exclamation-circle' },
    { title: 'page-error-404', icon: 'fa fa-exclamation-triangle' },
    { title: 'page-error-500', icon: 'fa fa-bomb' },
    { title: 'page-error-503', icon: 'flaticon-381-stopwatch' },
  ].filter((l) => admin.permissions.includes(l.permission))
  function toggleFunc() {
    const aaa = document.querySelector('#main-wrapper')
    // console.log('aaa', document.querySelector("#main-wrapper"));
    const x = aaa.classList.toggle('menu-toggle')
    setShowArrowIcon(x)
    return x
  }

  useEffect(() => {
    var btn = document.querySelector('.nav-control')
    btn.addEventListener('click', toggleFunc)

    return () => {}
  }, [])
  useEffect(() => {
    const p = location.pathname.split('/')
    setPath(p.pop())
    return () => {}
  }, [location])
  return (
    <div className="deznav">
      <PerfectScrollbar className="deznav-scroll">
        <MM className="metismenu" id="menu">
          {listMenu.map((item, i) => {
            return (
              <li
                key={i}
                className={`${listMenu.includes(path)}`}
                style={{ backgroundColor: path === item.title && '#0b2ea62e' }}
              >
                <button
                  className={`btn ai-icon ${path === `${item.title}` ? 'mm-active' : ''}`}
                  aria-expanded="false"
                  style={{
                    width: '100%',
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'center',
                    fontSize: '1.125rem',
                    padding: '16px',
                  }}
                  onClick={() => {
                    checkSizeDevice && toggleFunc()
                    history.push(`/${item.title}`)
                  }}
                >
                  <i className={item.icon} style={{ color: path === item.title && '#0b2a97' }}></i>
                  <span className="nav-text" style={{ color: path === item.title && '#0b2a97' }}>
                    {item.title}
                  </span>
                </button>
              </li>
            )
          })}
        </MM>
        {/* <div className="copyright">
            <p>
              <strong> Admin KongsalekPlus Dashboard</strong> © 2021 All Rights
              Reserved
            </p>
          </div> */}
      </PerfectScrollbar>
    </div>
  )
}
